import React, { Component } from 'react';
import ConfirmReappro from './ConfirmReappro';
import FormLayout from '../containers/FormLayout.jsx';
import Select from 'react-select'
import { Button, TableRow, TableCell, Box, IconButton } from '@material-ui/core';
import InputText, { InputSelect, InputSelectMagasin } from '../../../../commonModules/interface/form-input-inline';
import { CloseRounded, AddCircleOutlineRounded } from '@material-ui/icons';
import ProductLineCell from '../containers/ProductLineCell';
import { toast } from 'react-toastify';
import Photos from '../../../../commonModules/interface/input-files';
import { isEmpty } from 'lodash-es';
import axios from 'axios';
import { generateUniqueId } from '../../../../commonModules/utils/statsFunctions';

class FormReappro extends Component {
    state = {
        
        confirmSubmit:false,
        numberProd:1,
        updateDraft: false,
        // New reappro
        reappro:{
            shop: "",
            shop_dest: "",
            shopDisplay:{},
            shop_destDisplay:{},
            natureDisplay:{value:"reapprovisionnement", label:"Réapprovisionnement"},
            nature:"reapprovisionnement",
            transport: "",
            taxes: "",            
            comments: "",
            transfer_files_req: null,
            discount:0,
            total:0,
            products:[
                {
                    display:{value:"", label:""},
                    product_id:"",
                    quantity:"",
                    max:"",
                    stock_id:"",
                    stock_id_dest:"",
                   
                }
            ],
        },

        //errors?
        errors:{
            shop: "",
            shop_dest: "",
            quantity: "",
            nature:"",
            transport:"",
            discount:"",
            taxes:"",
            products:[
                {
                    product_id:"",
                    quantity:"",
                    
                }
            ],
        },
        uniqueID: generateUniqueId(),
        sending:false, //status de la requete
        form:<div></div> // Form with list of products
    }
    componentDidMount = () => {
        const { PRODUCTS, SHOPS, oldRea } = this.props;
        if (!isEmpty(oldRea)) {

            let numberProd = oldRea.products.length
            let newRea = {
                shop: oldRea.shop_id,
                shopDisplay: {
                    label: SHOPS[oldRea.shop_id].name, 
                    value: oldRea.shop_id,
                },
                shop_dest: oldRea.shop_dest,
                shop_destDisplay: {
                    label: SHOPS[oldRea.shop_dest] && SHOPS[oldRea.shop_dest].name, 
                    value: oldRea.shop_dest || "",
                },
                natureDisplay:{value:"reapprovisionnement", label:"Réapprovisionnement"},
                nature:"reapprovisionnement",
                transport: oldRea.transport,
                taxes: oldRea.taxes,            
                comments: oldRea.comments,
                transfer_files: oldRea.transfer_files,
                discount: oldRea.discount,
                total: oldRea.total,
                products: [],
            }
            let errors = Object.assign({}, this.state.errors)

            if( PRODUCTS ){
                Object.values(oldRea.products).forEach( (product, i) => {   
                    let prodInfo = PRODUCTS[product.product_id]   
                    const max = this.findMax(prodInfo.id, newRea.shop)    
                    
                    newRea.products.push(
                        {
                            display: {
                                value: prodInfo.id, 
                                label:`${prodInfo.marque} - ${prodInfo.name}`, 
                                // disabled: false
                            } ,
                            product_id: prodInfo.id,
                            quantity: product.quantity,
                            product_id : prodInfo.id,
                            max : max[0],
                            stock_id : max[1],
                            reduc_max : max[3],
                            price : max.price,
                            priceR : max.price,
                            priceHT : max.priceHT,
                            prod_tva_rate : max.tva,
                        }
                    )
                    
                    errors.products[i] = {
                        product_id: "",
                        quantity: "",
                    }
                })
            }

            this.setState({
                numberProd,
                reappro: newRea,
                errors
            }, () =>{
                this.createAddForm()
            }) 
        } 
    }

    createShopList = () => {
        const list = []
        
        const { reappro } = this.state
        const { SHOPS, AVAILABLE } = this.props
        if( AVAILABLE ){
            Object.values(SHOPS).map( shop => { 
                let selected = !!shop.shop_disabled
                if( reappro.shop === shop.id || reappro.shop_dest === shop.id  )   {  // already selected   
                    selected = true 
                } 
                list.push (       
                    {value:shop.id, label:shop.name, disabled:selected} 
                )
            })
        
        }
        return list
    
    }


    createProductList = () => {
        const { reappro } = this.state
        const  { AVAILABLE, PRODUCTS } = this.props
        const list = [{value:"", label:"Chosissez un Produit"}]
        if(AVAILABLE){
            Object.values(AVAILABLE).map( item => {   
                let selected = false
                reappro.products.map( prod => {   
                    if(prod.product_id  === item.product_id)   {  // already selected   
                        selected = true 
                    } 
                })
                if(item.shop_id === reappro.shop && item.quantity > 0){
                    list.push ({
                        value:item.product_id, 
                        label:`${PRODUCTS[ item.product_id ].marque} - ${PRODUCTS[ item.product_id ].name} — ${PRODUCTS[ item.product_id ].ref}`, 
                        disabled:selected
                    })
                }
            })
        }
        return list
    }

    handleSelect = (option, name) => {
        console.log("SELECT HANDLE",{option, name});
        let value = option.value
        let displayName = name +'Display'

        if(name === "nature"){
            this.setState({
                ...this.state,
                reappro:{
                    ...this.state.reappro,
                    transport:0,
                    taxes:0,
                    [name]:value,
                    [displayName]:option
                }
            }, () =>{
                this.createAddForm()
            }) 
            
        } else if(name === "shop"){
            console.log("change shop");
            
            this.setState({
                ...this.state,
                reappro:{
                    ...this.state.reappro,
                    [name]:value,
                    [displayName]:option,
                    products:[ // reset products array to prevent stock errors
                        {
                            display:{value:"", label:""},
                            product_id:"",
                            quantity:"",
                            max:"",
                            stock_id:"",
                            stock_id_dest:"",
                            
                        }
                    ],
                },
                numberProd:1
            }, () =>{
                this.createAddForm()
            }) 
        } else {

            this.setState({
                ...this.state,
                reappro:{
                    ...this.state.reappro,
                    [name]:value,
                    [displayName]:option
                }
            }, () =>{
                this.createAddForm()
            }) 
        }
    }
    
    handleSelectProducts = (option, index) => {
        console.log("SELECT HANDLE",{option, index});

        let value = option.value
        const shop = this.state.reappro.shop
        const max = this.findMax(value, shop)    

        let cpProducts = this.state.reappro.products
        cpProducts[index].product_id = value
        cpProducts[index].max = max[0]
        cpProducts[index].stock_id = max[1]
        cpProducts[index].reduc_max = max[3]
        cpProducts[index].display = option
        cpProducts[index].price = max.price
        cpProducts[index].priceR = max.price
        cpProducts[index].priceHT = max.priceHT
        cpProducts[index].prod_tva_rate = max.tva

        
        
        const maxDest = this.findMax(value, this.state.reappro.shop_dest, this.props.WAITING)
        console.log("REA, max shop_dest res", maxDest)

        cpProducts[index].stock_id_dest = maxDest[1]
        
        this.setState({
            ...this.state,
            reappro:{
                ...this.state.reappro,
                products:cpProducts,
            }
        }, () =>{
            this.createAddForm()
        })    
    }

// FORMS MANAGER
    findMax = (product_id, shop_id, list = this.props.AVAILABLE) => { // return available stock and it's id
        const { PRODUCTS } = this.props    
        let max = 0
        let stock_id = ""
        let reducMax = 0
        let price = 0
        let priceHT = 0
        let tva = 0
         Object.values(list).map( stock => {            
            if(stock.product_id === product_id  && stock.shop_id === shop_id ){
                max = stock.quantity
                stock_id = stock.id
                reducMax = PRODUCTS[stock.product_id].reduc_max
                tva = PRODUCTS[stock.product_id].tva_rate || 0
                price = PRODUCTS[stock.product_id].prix_venteTTC
                priceHT = PRODUCTS[stock.product_id].prix_venteHT
                return                    
            }
        })   
        // console.log("findMax", max,);
        return [max, stock_id, reducMax, price, priceHT, tva]
    }
    validateReduc = async ()=> {
        let TOTAL_MAX_REDUC = 0
        await this.state.reappro.products.map( prod => {
            TOTAL_MAX_REDUC += (prod.reduc_max * prod.quantity)
        })
        const res = (this.state.reappro.discount > TOTAL_MAX_REDUC) ? false : true
        console.log("INFO Discount, total reduc", this.state.reappro.discount, TOTAL_MAX_REDUC, res);
        return [res, TOTAL_MAX_REDUC]
    }
    
    createAddForm = () => {
        const tab = []
        const products = this.createProductList()

        for (let i = 0; i < this.state.numberProd; i++) {
            
            tab.push(
                <TableRow key={i} >  
                    {/* <TableCell>
                        {this.state.numberProd > 1 &&
                        <IconButton type="button" className="delete-line" onClick={()=>this.handleDeleteProd(i)}>
                            <CloseRounded  color="error" />
                        </IconButton>
                        }
                        <InputSelectMagasin
                            options={products}
                            value={this.state.reappro.products[i].display}
                            label="Produit"
                            placeholder="Selectionner un Produit"
                            onChange={ option => this.handleSelectProducts(option,i)}
                            error={this.state.errors.products[i].product_id}
                        />    
                    </TableCell>                       */}
                    <ProductLineCell
                        numberProd={this.state.numberProd}
                        handleDeleteProd={() => this.handleDeleteProd(i)}
                        options={products}
                        value={this.state.reappro.products[i].display}
                        onChange={option => this.handleSelectProducts(option,i)}
                        error={this.state.errors.products[i].product_id}
                        PRODUCTS={this.props.PRODUCTS}
                    />

                    <TableCell className="text-center" style={{width: "150px"}}>
                            <InputText 
                                type="number" 
                                min={1} 
                                max={this.state.reappro.products[i].max} 
                                step={10} 
                                className="form-control input-sm" 
                                onChange={this.handleChange} 
                                value={this.state.reappro.products[i].quantity} 
                                name={"prod_-quantity-"+i} 
                                title="Quantité"
                                error={this.state.errors.products[i].quantity}
                                helperText={this.state.reappro.products[i].max ? "Disponible : "+ this.state.reappro.products[i].max :"" }
                            />
                    </TableCell>
                </TableRow>                  
            )
        }
        this.setState({
            ...this.state,
            form:tab,
        })
        return tab;
    }
    handleAddProd = () => {//must add new line in the form to add a product to the sale
        this.setState({
            ...this.state,
            reappro:{
                ...this.state.reappro,
                products:[
                    ...this.state.reappro.products,{
                    display:{},
                    product_id:"",
                    quantity:"",
                    max:"",
                    stock_id:"",
                    stock_id_dest:"",
                }]
            },
            errors:{
                ...this.state.errors,
                products:[
                    ...this.state.errors.products,{                      
                    product_id:"",
                    quantity:"",
                }]
            },
            numberProd:this.state.numberProd+1,
            
        }, () => {
            // Mets a jour la liste des produits
            this.createAddForm()
        });  
    }
    handleAddProdByCSV = (productList) =>{
        console.log("Form Sales ,handleAddProdByCSV,",productList)
        const productListLocal = new Array();
        const productListLocalErr = new Array();
        const shop_id = this.state.reappro.shop
        if (shop_id === ""){
            toast.error("Shop must be selected")
            return
        }
        let nbOfProduct = 0;

        productList.forEach((value, key)=>{
            console.log("Form Reappro ,handleAddProdByCSV,",value[5],value[4])
            if (!value[4]){
                return
            }
            const max = this.findMax(value[5].id, shop_id)   
            const maxProductNumber =  max[0]
            const stock_id = max[1]
               
            if (stock_id ==="" || typeof stock_id === "undefined"){
                toast.error( "Produit '"+ value[5].name+ "' pas disponible dans le magasin")
                return
            }
            //Check stock maximal
            if (maxProductNumber<value[2]) {
                toast.error( "Produit '"+ value[5].name+ "' pas de quantite suffisante dans le magasin")
                return
            }
            nbOfProduct++

            const maxDest = this.findMax(value, this.state.reappro.shop_dest, this.props.WAITING)

            const productEntry = {
                display: {value:value[5].id,label:value[0]},
                product_id: value[5].id,
                quantity: value[2],
                max: maxProductNumber,
                stock_id: stock_id,
                stock_id_dest:maxDest,
            };
            const productEntryErr = {                      
                product_id:"",
                quantity:"",
            };
            productListLocal.push(productEntry);
            productListLocalErr.push(productEntryErr);
        })
        console.log("Form Reappro ,handleAddProdByCSV,productListLocal",productListLocal)
        if (productListLocal.length > 0){
            console.log("Form Reappro ,handleAddProdByCSV,Add product",productListLocal.length)
            this.setState({
                ...this.state,
                reappro:{
                    ...this.state.reappro,
                    products:[...productListLocal]
                },
                errors:{
                    ...this.state.errors,
                    products:[...productListLocalErr]
                },
                numberProd:nbOfProduct,
            }, () =>{
                this.createAddForm()
            })  
        }
        toast.info( "Importation réussi de "+nbOfProduct+" produits")
    }
    handleDeleteProd = (index) => {
        let cpProducts = [].concat(this.state.reappro.products)
        let cpErrors = [].concat(this.state.errors.products)
        let total = 0;

        cpProducts = [
            ...cpProducts.slice(0,index),
            ...cpProducts.slice(index +1),
        ]
        cpErrors = [
            ...cpErrors.slice(0,index),
            ...cpErrors.slice(index +1),
        ]
        cpProducts.map( prod => {
            if ( prod.priceR && prod.quantity && prod.priceTotal){
                total += parseFloat(prod.priceTotal)
            }
        }) 
        this.setState({
            ...this.state,
            reappro:{
                ...this.state.reappro,
                products: cpProducts,
                total
            },
            errors:{
                ...this.state.errors,
                products: cpErrors
            },
            numberProd: this.state.numberProd - 1,
            
        }, () => {
            // Mets a jour la liste des produits
            this.createAddForm()
        });   
    }
    handleChange =  (e) => {  
        const field = e.target.name
        const value = e.target.value
        const regex = /^[0-9\b]+$/ // int only
        
        if(field.startsWith("prod_")){
            // field = "prod_-quantity-4" || "prod_-product_id-4"

            let splitTab = field.split("-")
            let name = splitTab[1]
            let index = splitTab[2]
            console.log("[INFO] INDEX field", splitTab, splitTab[0], splitTab[1]);

            let cpProducts = [].concat(this.state.reappro.products)
            cpProducts[index][name] = value
            if(name === "quantity" || name === "price" || name === "priceTotal") {   
                if(value ==="" || regex.test(value)){// update value only if its a int
                let discount = 0;
                             
                    this.setState({
                        ...this.state,
                        reappro:{
                            ...this.state.reappro,
                            products:cpProducts,
                            discount,
                        }
                    }, () => {
                        // Mets a jour la liste des produits
                        this.createAddForm()
                    });
                }
            } else {
                this.setState({
                    ...this.state,
                    reappro:{
                        ...this.state.reappro,
                        products:cpProducts,
                    }
                }, () => {
                    // Mets a jour la liste des produits
                    this.createAddForm()
                });
            }
        } else {
            this.setState({
                ...this.state,
                reappro:{
                    ...this.state.reappro,
                    [field]:value
                }
            }, () => {
                // Mets a jour la liste des produits
                this.createAddForm()
            });
        }
    }
    
    setFiles = (list) => {
        console.log("[INFO] SETFILES", list);
        
        this.setState({
            ...this.state,
            reappro:{
                ...this.state.reappro,
                transfer_files_req:list
            }
        })
    }

    validate = async (updateDraft) => {
        const { reappro } = this.state
        let noErrors = true
        let errors = this.state.errors
        const notRequired = ["comments"]
        // const validDiscount = await this.validateReduc()

        Object.keys(reappro).map(field => {
            console.log(field);
            
            if(
                (reappro[field] === "" && !notRequired.includes(field)) || 
                reappro[field] === [] ){// input is empty  
                    noErrors = false
                    errors[field]="Veuillez remplir ce champ"
                    
            } else if(field === "products"){
                reappro.products.map( (item, j) => {
                    Object.keys(item).map( field2 => { // field2 product_id || quantity
                        
                        if(field2 === "max" || field2 === "stock_id_dest" ){
                            errors.products[j][field2] = ""
                        } else if(item[field2] === "" || item[field2] === 0 || item[field2] === "0" ){
                            noErrors = false
                            errors.products[j][field2] ="Veuillez remplir ce champ"
                        } else if(parseInt(item.max) < parseInt(item.quantity)){
                            noErrors = false
                            errors.products[j].quantity = "stock insuffisant"
                        } else {
                            errors.products[j][field2] = ""
                        }

                    })
                })

            } else {// not empty
                errors[field]=""   
            }
        })
                
        // if(validDiscount[0] === false){ 
        //     console.log("Not validate discount", validDiscount);
        //     noErrors = false
        //     errors.discount ="Reduction trop élevée"
        // }
        console.log("[INFO] NOERRORS = ",noErrors);
        console.log("[INFO] VALIDATE, ERRORS = ",errors);
        
        this.setState({
            ...this.state,
            errors : errors
        }, () => {
            // Mets a jour la liste des produits
            this.createAddForm()
        });
        if(noErrors){
            this.setState({
                confirmSubmit: true,
                updateDraft,
                
            })
        } else {// !VALIDATE
            toast.error(  "Le formulaire contient des erreurs")
        }
    }
    
    handleSubmit = async () => {
        this.setState({
            sending: true,
        })

        const sale = Object.assign({}, this.state.reappro);
        sale.shop_id = sale.shop
        sale.transport = parseFloat(sale.transport)                      
        sale.taxes = parseFloat(sale.taxes) 
        sale.discount = parseFloat(sale.discount) 
        sale.unique_id = this.state.uniqueID
        sale.nature = "reapprovisionnement"
        for (let i = 0; i < sale.products.length; i++){
            sale.products[i].quantity = parseInt(sale.products[i].quantity)
            sale.products[i].priceUReal = parseFloat(sale.products[i].priceUReal)
        }
        if(!isEmpty(this.props.oldRea) ) {
            sale.id = this.props.oldRea.id
            if( this.props.fromResa ) {
                //Permet de suivre la précédente résa
                sale.resa_demand_id = this.props.oldRea.id
                sale.resa_creator = this.props.oldRea.user_id
                sale.id = ""
            }
            if( this.props.sendTo ) {
                //Permet de suivre la précédente résa
                sale.resa_demand_id = this.props.oldRea.id
                sale.resa_creator = this.props.oldRea.user_id
                // sale.resa_demand_id = ""
                // sale.resa_creator = ""
                sale.id = ""
            }
        }
        
        if(this.props.draft && this.state.updateDraft){
            sale.nature = "draft"
            let res = await axios.post("/stocks/addData", {
                page: "reappro/draft/new",
                data: sale
            }) 
            if(res.data.error){
                console.log("ERROR", res.data.error);
                this.setState({
                    sending: false,
                })
                let errorMessage = "Une erreur est survenue";
                if (typeof res.data.error === 'string') {
                    errorMessage = res.data.error;
                } else if (res.data.error && typeof res.data.error === 'object') {
                    errorMessage = res.data.error.message || res.data.error.error || JSON.stringify(res.data.error);
                }
                toast.error(errorMessage)
            } else{
                console.log("fetched");
                //success 
                this.setState({
                    sending: false,
                })
                toast.info("Opération enregistrée avec succès")
                // this.props.filterList(undefined, undefined)
                this.props.handleClose()
                if (this.props.closeSubmit && typeof this.props.closeSubmit === 'function') {
                    this.props.closeSubmit()
                }
            }                
        } else {
        
            try {
                const resp = await this.props.createSale(sale, "reappro")
                console.log("fetched");
                //success 
                this.setState({
                    sending: false,
                })
                toast.info("Opération enregistrée avec succès")
                // this.props.filterList(undefined, undefined)
                this.props.handleClose()
            }catch(err){
                console.log("ERROR",err.message);
                this.setState({
                    sending: false,
                })
                toast.error("ERROR "+ err.message)
            }
                
        }

    }
    render() {
        const shops = this.createShopList()
        return (
            <div className="card-text">
                {this.state.confirmSubmit &&
                    <ConfirmReappro 
                        handleClose={ () => this.setState({ confirmSubmit: false })}
                        handleSubmit={ this.handleSubmit }
                        sending={this.state.sending}
                        reappro={this.state.reappro}
                    />
                }
              
                <Box p={2}>
                        
                    <InputSelectMagasin
                        label="Magasin Source"
                        options={shops}
                        value={this.state.reappro.shopDisplay}
                        onChange={ option => this.handleSelect(option,"shop")}
                        error={this.state.errors.shop}
                        // isOptionDisabled={ option => option.disabled === true}
                    /> 
                    

                    <InputSelectMagasin
                        label="Magasin Destinataire"
                        options={shops}
                        value={this.state.reappro.shop_destDisplay}
                        onChange={ option => this.handleSelect(option,"shop_dest")}
                        error={this.state.errors.shop_dest}
                    /> 
                    
                    <InputText 
                        type="text" 
                        id="transport" 
                        onChange={this.handleChange} 
                        value={this.state.reappro.transport} 
                        name="transport" 
                        title="Coût Transport" 
                        error={this.state.errors.transport}
                    />
                    
                    <InputText 
                        type="text" 
                        id="taxes" 
                        // className="form-control input-sm" 
                        onChange={this.handleChange} 
                        value={this.state.reappro.taxes} 
                        name="taxes" 
                        title="Autres Taxes"
                        error={this.state.errors.taxes}
                    />
                    <InputText 
                        type="text" 
                        id="comments"
                        value={this.state.reappro.comments} 
                        name="comments" 
                        onChange={this.handleChange}
                        title="Remarques"
                        multi
                        rows={2}
                    />
                    <Box p={1}>
                        <label htmlFor="transfer_files_req" className="control-label">Documents</label>
                        <Photos
                            saved={this.props.oldRea ? this.props.oldRea.transfer_files : null}
                            photoList={this.setFiles} 
                            photos={this.state.reappro.transfer_files_req === null ? [] : this.state.reappro.transfer_files_req } 
                            file 
                        />
                        
                    </Box>
                    <Box>
                        <FormLayout 
                            {...this.props} 
                            title={"Produits"}
                            rea
                            createAddForm={this.state.form}
                            onClick={this.handleAddProd}
                            onClickForCSVUpload={this.handleAddProdByCSV}
                            colSpan={2}
                        /> 
                    </Box>

                    <Box p={2}>
                        <div className="pull-right">
                            {(isEmpty(this.props.oldRea) || this.props.draft ) &&
                                <Button color="secondary" variant="outlined" onClick={() => this.validate(true)}>Enregistrer le Brouillon</Button>
                            }
                            {(!isEmpty(this.props.oldRea) || !this.props.draft ) &&
                                <Button color="primary" variant="contained" onClick={() => this.validate(false)}>Valider le Réappro</Button>
                            }
                            <Button color="secondary" onClick={this.props.handleClose}>Annuler</Button>
                        </div>
                    </Box>
                </Box>
            </div>
        );
    }
}

export default FormReappro;